import  { useMemo } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const BarChartSample = ({ month }) => {
  const currentMonth = new Date();

  const monthsList = useMemo(() => {
    const result = [];
    const year = currentMonth.getFullYear();
    const currentMonthIndex = currentMonth.getMonth();

    const maxIndex = currentMonthIndex < 6 ? 5 : currentMonthIndex;

    for (let m = 0; m <= maxIndex; m++) {
      const key = `${year}-${String(m + 1).padStart(2, "0")}`;
      result.push(key);
    }
    return result;
  }, []);

  const monthMap = {};
  if (Array.isArray(month)) {
    month.forEach((item) => {
      monthMap[item.month] = {
        amount: Number(item.total_amount),
        orders: Number(item.total_order_count),
      };
    });
  }

  const chartData = monthsList.map((m) => {
    const date = new Date(`${m}-01`);
    const formattedMonth = date.toLocaleDateString("en-US", { month: "short" });

    return {
      Month: formattedMonth,
      Amount: monthMap[m]?.amount || 0,
      Orders: monthMap[m]?.orders || 0,
    };
  });

  return (
    <ResponsiveContainer width="100%" height={250}>
      <BarChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="Month" />
        <YAxis />
        <Tooltip
          formatter={(value, name, props) => {
            const { payload } = props;
            if (name === "Amount") {
              return [`₹${value.toLocaleString()}`, "Amount"];
            }
            return [value, name];
          }}
          labelFormatter={(label, payload) => {
            const orders = payload[0]?.payload?.Orders || 0;
            return `${label} - Orders: ${orders}`;
          }}
        />
        <Bar dataKey="Amount" fill="#8884d8" radius={[6, 6, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BarChartSample;
